/**
 * Словник: ru.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_ru.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Ожидание другого участника...",
  connectionLost: "Соединение потеряно",
  peerLeft: "👋 Другой участник покинул звонок",
  connectionError: "🚫 Ошибка соединения",
  connectionFailedTryAgain: "🚫 Не удалось подключиться к серверу. Попробуйте еще раз.",
  reconnectionFailed: "🚫 Соединение потеряно. Не удалось восстановить после {attempts} попыток.",
  connectionErrorWithDetails: "🚫 Ошибка соединения: {error}",
  speakerLoud: "Громко",
  speakerEar: "Ухо",
  copyRoomId: "Скопировать ID комнаты",
  share: "Поделиться",
  linkCopied: "🔗 Ссылка скопирована!",
  idCopied: "🆔 ID скопирован!",
  startMeeting: "Начать встречу",
  chooseAction: "Выберите действие",
  createNewRoom: "Новая комната",
  scheduleCall: "Запланировать звонок",
  calendarOpened: "📅 Календарь успешно открыт",
  linkCopiedToClipboard: "🔗 Ссылка скопирована в буфер обмена",
  enterRoomId: "Введите ID комнаты",
  roomIdValidationError: "Room ID может содержать только буквы, цифры и дефисы",
  joinRoom: "ВОЙТИ",
  termsAndPrivacyHelp: "Условия и конфиденциальность | Помощь",
  invite: "Пригласить",
  mySettings: "Мои настройки",
  peerSettings: "Настройки собеседника",
  blockRemoteControl: "Заблокировать удалённое управление",
  iAgreeToTerms: "Я согласен с правилами сервиса",
  termsOfUse: "Условия использования",
  privacyPolicy: "Политика конфиденциальности",
  howToUse: "Как пользоваться",
  termsAcceptanceRequired: "Для использования сервиса необходимо согласиться с правилами",
  ok: "ОК",
  permissionsRequired: "Требуются разрешения",
  permissionsNeededMessage: "Это приложение требует следующие разрешения для правильной работы:",
  permissionsNote: "Примечание: При изменении разрешений в Настройках iOS перезапустит приложение. Это нормальное поведение.",
  permissionsEnableMessage: "Пожалуйста, включите эти разрешения в настройках устройства, чтобы продолжить.",
  cancel: "Отмена",
  openSettings: "Открыть настройки",
  websocketError: "Ошибка WebSocket",
  roomFull: "Комната заполнена",
  timeExpired: "Время истекло",
  remaining: "ост.",
  mediaPermissionsRequired: "Для видеозвонков требуется доступ к камере и микрофону. Пожалуйста, предоставьте разрешения в браузере.",
  mediaPermissionsRequiredMobile: "Для видеозвонков требуется доступ к камере и микрофону. Пожалуйста, предоставьте разрешения в настройках приложения.",
  browserSettings: "Настройки браузера",
  openAppSettings: "Открыть настройки",
  grantPermissions: "Предоставить разрешения",
  permissionsNotGranted: "Разрешения не предоставлены. Пожалуйста, предоставьте разрешения для продолжения.",
  permissionRequestError: "Ошибка при запросе разрешений: {error}",
  camera: "Камера",
  microphone: "Микрофон",
  cameraDescription: "Для передачи видео",
  microphoneDescription: "Для передачи аудио",
  continueWithoutPermissions: "Продолжить без разрешений",
  mediaPermissionsRequiredFallback: "Для видеозвонков требуется доступ к камере и микрофону. Пожалуйста, предоставьте разрешения в настройках браузера.",
  mediaPermissionsRequiredMobileFallback: "Для видеозвонков требуется доступ к камере и микрофону. Пожалуйста, предоставьте разрешения в настройках приложения.",
  browserSettingsFallback: "Настройки браузера",
  openAppSettingsFallback: "Открыть настройки",
  permissionsPermanentlyDenied: "Разрешения отклонены навсегда. Пожалуйста, включите их в настройках приложения.",
  continueText: "Продолжить",
  mirror: "Зеркало",
  fitContain: "Вместить",
  fitCover: "Заполнить",
  switchCamera: "Камера",
  block: "Заблок.",
  pip: "PiP",
  mic: "Мик",
  video: "Видео",
  speaker: "Динамик",
  readyToConnect: "Готовы общаться?",
  startOneOnOne: "Начать видеозвонок",
  createPrivateLink: "Ссылка — за секунду",
  welcomeExplainer: "Создайте ссылку и отправьте её кому угодно. Она откроется даже без приложения.",
  joinHaveLink: "Есть ссылка?",
  joinFieldHint: "Вставьте ссылку или ID",
  roomInputInvalid: "Вставьте ссылку на звонок или ID комнаты (буквы, цифры и дефис)",
  guestTitle: "Вас приглашают на видеозвонок",
  guestBody: "Комната готова. Собеседник увидит вас, как только вы присоединитесь.",
  guestJoin: "Присоединиться",
  guestFreeNote: "Присоединение всегда бесплатно",
  guestCreateOwn: "Создать свою комнату",
  guestInvalidTitle: "Похоже, ссылка повреждена",
  guestInvalidBody: "Попросите прислать ссылку ещё раз или создайте свою комнату.",
  inviteCardTitle: "Комната готова",
  inviteCardBody: "Отправьте ссылку тому, с кем хотите поговорить",
  inviteShareLink: "Поделиться ссылкой",
  inviteCopy: "Скопировать",
  inviteBrowserHint: "Откроется в любом браузере. Устанавливать приложение не нужно.",
  inviteSentHint: "Отправили? Собеседник появится здесь, как только откроет ссылку.",
  inviteShareMessage: "Привет! Присоединяйся к моему видеозвонку в One2One 👋\nПросто открой ссылку. Она работает в браузере, ничего устанавливать не нужно:\n{link}",
  copyLink: "Скопировать ссылку",
  consentBannerText: "Разрешить сбор статистики использования? Она показывает, какими функциями пользуются. Содержимое звонков туда никогда не попадает.",
  consentAllow: "Разрешить",
  consentDeny: "Не разрешать",
  privacySettingsLink: "Настройки статистики",
} as const;
